<template>
    <div class="modal" :class="{ 'open_modal': showSlCategoryModal}">
        <div class="modal_overlay"></div>
        <div class="modal_inner max_height_80">
            <div class="modal_header"> 
                <span class="close_icon close_icon_sm" @click="closeModal()">×</span>
                <h2>{{ $t('special_lecture.special_lecture_category.add_special_lecture_category') }}</h2>
            </div>
            <div class="modal_wrapper">
                <div class="modal_content modal_1080p">
                    <div class="container">
                        <div class="row">
                            <div class="col_12">
                                <div :class="['form_row_inline', {'has_error': errorFor('name')}]">
                                    <label>{{ $t('special_lecture.special_lecture_category.name') }}</label>
                                    <input type="text" class="form_global" v-model="form.name">
                                    <v-errors :errors="errorFor('name')" />
                                </div>
                                <div :class="['form_row_inline', {'has_error': errorFor('status')}]">
                                    <label>{{ $t('special_lecture.special_lecture_category.status') }}</label>
                                    <div class="form_inline">
                                        <div class="form_radio">
                                            <input type="radio" id="active" value="1" v-model="form.status">
                                            <label for="active">{{ $t('special_lecture.special_lecture_category.active') }}</label>
                                        </div>
                                        <div class="form_radio">
                                            <input type="radio" id="inactive" value="0" v-model="form.status">
                                            <label for="inactive">{{ $t('special_lecture.special_lecture_category.inactive') }}</label>
                                        </div>
                                    </div>
                                    <v-errors :errors="errorFor('status')" />
                                </div>
                                <div :class="['form_row_inline', {'has_error': errorFor('sort')}]">
                                    <label>{{ $t('special_lecture.special_lecture_category.sort') }}</label>
                                    <input type="number" class="form_global" v-model="form.sort">
                                    <v-errors :errors="errorFor('sort')" />
                                </div>
                                <div class="row">
                                    <div :class="['col_2']">
                                        <div class="custom_label">
                                            <label>{{ $t('special_lecture.special_lecture_category.select_dropdown_item') }}</label>
                                        </div>
                                    </div>
                                    <div :class="['col_3']">
                                        <div :class="['form-group', {'has_error': errorFor('grade_id')}]">
                                            <label>{{ $t('common.grade') }}</label>
                                            <select v-model="form.grade_id" class="form_global" :disabled="form.grade_group_id != ''">
                                                <option value="">{{ $t('common.select_grade') }}</option>
                                                <option :value="grade.id" v-for="grade in grades" :key="'grade_'+grade.id">{{ grade.name }}</option>
                                            </select>
                                            <v-errors :errors="errorFor('grade_id')" />
                                        </div>
                                    </div>
                                    <div :class="['col_3']">
                                        <div :class="['form-group', {'has_error': errorFor('semester_id')}]">
                                            <label>{{ $t('common.semester') }}</label>
                                            <select v-model="form.semester_id" class="form_global" :disabled="form.grade_group_id != ''">
                                                <option value="">{{ $t('common.select_semester') }}</option>
                                                <option :value="semester.id" v-for="semester in semesters" :key="'semester_'+semester.id">{{ semester.name }}</option>
                                            </select>
                                            <v-errors :errors="errorFor('semester_id')" />
                                        </div>
                                    </div>
                                    <div :class="['col_4']">
                                        <div :class="['form-group', {'has_error': errorFor('grade_group_id')}]">
                                            <label>{{ $t('special_lecture.grade_group.title') }}</label>
                                            <select v-model="form.grade_group_id" class="form_global" :disabled="form.grade_id != '' || form.semester_id != ''">
                                                <option value="">{{ $t('special_lecture.grade_group.select_grade_group') }}</option>
                                                <option :value="gradeGroup.id" v-for="gradeGroup in gradeGroups" :key="'gradeGroup_'+gradeGroup.id">{{ gradeGroup.name }}</option>
                                            </select>
                                            <v-errors :errors="errorFor('grade_group_id')" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col_6">
                                        <div class="form_row_inline">
                                            <label>{{ $t('special_lecture.special_lecture_category.desktop_thumbnail') }}</label>
                                            <input type="file" ref="desktop_thumbnail" class="form_global" @input="desktopThumbnailUpload($event)">
                                            <v-errors :errors="errorFor('desktop_thumbnail')"></v-errors>
                                        </div>
                                        <div v-if="tempDesktopThumbnail || form.desktop_thumbnail">
                                            <div class="inner mb_10">
                                                <img v-if="tempDesktopThumbnail" :src="tempDesktopThumbnail" alt="" width="150">
                                                <img v-else :src="form.desktop_thumbnail" alt=""  width="150">
                                                <span class="close_icon" @click="removeTempDesktopThumbnail"></span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col_6">
                                        <div class="form_row_inline">
                                            <label>{{ $t('special_lecture.special_lecture_category.mobile_thumbnail') }}</label>
                                            <input type="file" ref="mobile_thumbnail" class="form_global" @input="mobileThumbnailUpload($event)">
                                            <v-errors :errors="errorFor('mobile_thumbnail')"></v-errors>
                                        </div>
                                        <div v-if="tempMobileThumbnail || form.mobile_thumbnail">
                                            <div class="inner mb_10">
                                                <img v-if="tempMobileThumbnail" :src="tempMobileThumbnail" alt="" width="150">
                                                <img v-else :src="form.mobile_thumbnail" alt=""  width="150">
                                                <span class="close_icon" @click="removeTempMobileThumbnail"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col_12">
                                <div class="d_flex_end">
                                    <button class="btn btn_blue ml_10 add_update" @click.prevent="submit()">{{ $t('common.save') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name:'sl-category-modal',
        data(){
            return{
                baseUrl: process.env.VUE_APP_BASE,
                grades:[],
                semesters:[],
                gradeGroups:[],
                form:{
                    name: '',
                    status: 1,
                    sort: '',
                    desktop_thumbnail: '',
                    mobile_thumbnail: '',
                    grade_id: '',
                    semester_id: '',
                    grade_group_id: '',
                },
                tempDesktopThumbnail:'',
                tempMobileThumbnail:'',
                slCategoryId:'',
            }
        },
        props:{
            showSlCategoryModal:{
                type: Boolean,
                required: true
            },
            specialLectureCategory:{
                type: Object,
                required: false
            }
        },
        created(){
            this.axios.get('/grades').then((response) => this.grades = response.data.data);
            this.axios.get('/semesters').then((response) => this.semesters = response.data.data);
            this.axios.get('/grade-groups').then((response) => this.gradeGroups = response.data.data);
            if(this.specialLectureCategory){
                this.form.name = this.specialLectureCategory.name
                this.form.status = this.specialLectureCategory.status ? '1' : '0'
                this.form.sort = this.specialLectureCategory.sort
                this.form.desktop_thumbnail = this.specialLectureCategory.desktop_thumbnail
                this.form.mobile_thumbnail = this.specialLectureCategory.mobile_thumbnail
                this.form.grade_id = this.specialLectureCategory.grade_id ? this.specialLectureCategory.grade_id : ''
                this.form.semester_id = this.specialLectureCategory.semester_id ? this.specialLectureCategory.semester_id : ''
                this.form.grade_group_id = this.specialLectureCategory.grade_group_id ? this.specialLectureCategory.grade_group_id : ''
            }
        },
        methods:{
            closeModal(){
                this.$emit("closeModal");
            },
            desktopThumbnailUpload(e) {
                this.form.desktop_thumbnail = e.target.files[0]
                this.tempDesktopThumbnail = URL.createObjectURL(e.target.files[0]);
            },
            removeTempDesktopThumbnail(){
                this.tempDesktopThumbnail = ''
                this.form.desktop_thumbnail = ''
                this.$refs.desktop_thumbnail.value = null;
            },
            mobileThumbnailUpload(e) {
                this.form.mobile_thumbnail = e.target.files[0]
                this.tempMobileThumbnail = URL.createObjectURL(e.target.files[0]);
            },
            removeTempMobileThumbnail(){
                this.tempMobileThumbnail = ''
                this.form.mobile_thumbnail = ''
                this.$refs.mobile_thumbnail.value = null;
            },
            submit() {
                this.allErrors = null;
                this.loading = true;

                let formData = new FormData()

                Object.keys(this.form).forEach(key => {
                    formData.append(key, this.form[key] ? this.form[key] : '');
                })

                if (this.specialLectureCategory) {
                    formData.append('_method', 'PATCH')
                    this.axios.post('/special-lecture-categories/' + this.specialLectureCategory.id, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    })
                    .then(() => {
                        this.$emit("closeModal");
                        this.showSuccessMsg(this.$t('common.updateSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                } else {
                    this.axios.post('/special-lecture-categories/', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    })
                    .then(() => {
                        this.$emit("closeModal");
                        this.showSuccessMsg(this.$t('common.addSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>
.form_row_inline label{
    width: 200px;
}
.custom_label{
    margin-top: 25%;
}

.custom_label label{
    min-width: 100px;
    padding-right: 10px;
    color: #000;
    font-weight: bold;
    font-size: 12.63px;
    margin-top: 17px;
}
</style>